import React, { useCallback, useState } from "react";
import { Alert, Button, Form, Modal } from "react-bootstrap";
import { updateProject } from "../../services/projectService";

interface EditDescriptionModalProps {
  show: boolean;
  projectId: string;
  currentDescription: string;
  onHide: () => void;
}

const EditDescriptionModal: React.FC<EditDescriptionModalProps> = ({
  show,
  projectId,
  currentDescription,
  onHide,
}) => {
  const [description, setDescription] = useState(currentDescription);
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = useCallback(
    async (event: React.FormEvent) => {
      event.preventDefault();
      setError(null);
      setIsSaving(true);

      try {
        await updateProject(projectId, { description });
        onHide();
      } catch {
        setError("Failed to update description. Please try again.");
      } finally {
        setIsSaving(false);
      }
    },
    [projectId, description, onHide],
  );

  const handleClose = () => {
    if (!isSaving) {
      setError(null);
      onHide();
    }
  };

  return (
    <Modal
      className="basic-modal"
      show={show}
      onHide={handleClose}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Edit Description</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          {error && <Alert variant="danger">{error}</Alert>}
          <Form.Group controlId="projectDescription">
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              disabled={isSaving}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={isSaving}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSubmit} disabled={isSaving}>
          {isSaving ? "Saving..." : "Save"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditDescriptionModal;
